// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"847be414","213":"00ddc0d8","239":"fd907f5c","453":"8ed1fa66","904":"51968403"}[chunkId] + ".chunk.js";
};